<h3 mat-dialog-title>
  {{ title }}
</h3>
<div mat-dialog-content>
  <p *ngIf="message">{{ message }}</p>
  <form [formGroup]="form">
    <mat-checkbox *ngIf="formField.fieldType === 'checkbox' else input" [formControlName]="formField.name">{{formField.name | translate}}</mat-checkbox>
    <ng-template #input>
      <mat-form-field>
        <mat-label>
          {{ formField.textName || formField.name | translate }}
        </mat-label>
        <input matInput [formControlName]="formField.name" [type]="formField.formFieldType" [pattern]="formField.pattern"
               [minlength]="formField.minLength" [maxlength]="formField.maxLength" [min]="formField.min" [max]="formField.max" [step]="formField.step">
        <mat-error [appMatErrorMessages]="formField.validators"></mat-error>
      </mat-form-field>
    </ng-template>
  </form>
</div>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close>{{ cancelText }}</button>
  <button mat-button [mat-dialog-close]="form.value" [disabled]="!form.valid">{{ confirmText }}</button>
</div>